import { render, staticRenderFns } from "./EditOrderMovementDetails.vue?vue&type=template&id=10bedb89&scoped=true"
import script from "./EditOrderMovementDetails.vue?vue&type=script&lang=js"
export * from "./EditOrderMovementDetails.vue?vue&type=script&lang=js"
import style0 from "./EditOrderMovementDetails.vue?vue&type=style&index=0&id=10bedb89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bedb89",
  null
  
)

export default component.exports